import {
  type Product,
  type ProductAPI,
  type VariationProperty,
} from '@/features/shop/services/Product/types'

type SubstitutionsById = Record<
  string,
  {
    substitutions: Product[]
    state: SubstitutionForProductState | ''
  }
>

export interface BackupPreferences {
  [key: string]: RetrievedPreference
}

export interface DoNotSub {
  do_not_sub?: boolean | null
}

export type RetrievedPreference = Product | DoNotSub

export type RetrievedPreferenceAPI = ProductAPI | DoNotSub

export enum SubstitutionForProductState {
  lowStock = 'low_stock',
  available = 'available',
  outOfStock = 'out_of_stock',
}

export type SubstitutionsForProductResponse = {
  preferred?: RetrievedPreferenceAPI[] | null
  personalized?: ProductAPI[] | null
  generic?: ProductAPI[] | null
  state?: SubstitutionForProductState | null
}

export interface SubstitutionsForProductsResponse {
  substitutions: Record<string, SubstitutionsForProductResponse> | null
}

export type FetchPreferencesResponse = Record<string, RetrievedPreferenceAPI[]> | null

export interface SubstitutionsActionPayload {
  preferredSubstitution: RetrievedPreference
  productId: number
  substitutions: Product[]
  state: SubstitutionForProductState | ''
}

export type SubstitutionsForProductsPayload = {
  substitutionsById: SubstitutionsById
  preferences: BackupPreferences
}

export type SavePreferenceVariables = {
  productId: number
  backupProduct?: Pick<Product, 'id'> | Product
  doNotSub?: boolean
}
export type SubstituteProduct = {
  id: number
  name: string
  brandName: string
  price: number
  onSale: boolean
  salePrice: number
  parentProductId?: number | null
  variationSize?: string | null
  variationColor?: string | null
  variationProperties?: VariationProperty[] | null
  universal_id: string
}
